module.exports = __webpack_public_path__ + "img/marker_four_yellow2.2315a354.png";